import React from "react";

const About = () => (
  <section className="about" id="about">
    <h2>About</h2>
    <p>
    Maryville Massage Works offers expert deep tissue, sports, myofascial, lymphatic, relaxation, and 
    neuromuscular massage therapy — now available both at our convenient Maryville location,
    and through mobile services. Providing relief, recovery, and results for busy professionals 
    and active individuals across East Tennessee for over 10 years.
    </p>
  </section>
);

export default About;
